import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../../css/Mirissa.css";

import { storage } from "../../firebase";
import { ref, getDownloadURL } from "firebase/storage";

function Kandy() {

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const [imgHero, setImgHero] = useState("");

  // Top images
  const [kandy1, setKandy1] = useState("");
  const [kandy2, setKandy2] = useState("");

  // Extra gallery
  const [kandy3, setKandy3] = useState("");
  const [kandy4, setKandy4] = useState("");
  const [kandy5, setKandy5] = useState("");

  // Activity icons
  const [act1, setAct1] = useState("");
  const [act2, setAct2] = useState("");
  const [act3, setAct3] = useState("");
  const [act4, setAct4] = useState("");
  const [act5, setAct5] = useState("");
  const [act6, setAct6] = useState("");
  const [act7, setAct7] = useState("");
  const [act8, setAct8] = useState("");
  const [act9, setAct9] = useState("");

  // Bottom gallery
  const [kandy6, setKandy6] = useState("");
  const [kandy7, setKandy7] = useState("");

  useEffect(() => {

    getDownloadURL(ref(storage, "kandy-hero.jpg")).then(setImgHero);

    // TOP GALLERY
    getDownloadURL(ref(storage, "kandy1.jpg")).then(setKandy1);
    getDownloadURL(ref(storage, "kandy2.jpg")).then(setKandy2);

    // EXTRA GALLERY
    getDownloadURL(ref(storage, "kandy3.jpg")).then(setKandy3);
    getDownloadURL(ref(storage, "kandy4.jpg")).then(setKandy4);
    getDownloadURL(ref(storage, "kandy5.jpg")).then(setKandy5);

    // ACTIVITY IMAGES
    getDownloadURL(ref(storage, "Temple of the Tooth.png")).then(setAct1);
    getDownloadURL(ref(storage, "Kandyan dance.png")).then(setAct2);
    getDownloadURL(ref(storage, "Kandy Lake.png")).then(setAct3);
    getDownloadURL(ref(storage, "Peradeniya Botanical Garden.png")).then(setAct4);
    getDownloadURL(ref(storage, "Udawattakele Forest Reserve.png")).then(setAct5);
    getDownloadURL(ref(storage, "Picturesque landscapes.png")).then(setAct6);
    getDownloadURL(ref(storage, "Hanthana Bird Park.png")).then(setAct7);
    getDownloadURL(ref(storage, "Unwinding amidst scenic views.png")).then(setAct8);
    getDownloadURL(ref(storage, "Cool climate.png")).then(setAct9);

    // BOTTOM GALLERY
    getDownloadURL(ref(storage, "kandy6.jpg")).then(setKandy6);
    getDownloadURL(ref(storage, "kandy7.jpg")).then(setKandy7);

  }, []);


  return (
    <div className="destination-container">
      {/* HERO SECTION */}
      <section
        className="mirissa-hero"
        style={{ backgroundImage: `url(${imgHero})` }}
        data-aos="fade-down"
      >
        <div className="overlay">
          <h1>Kandy</h1>
        </div>
      </section>

      {/* MAIN CONTENT */}
      <section className="mirissa-container">
        {/* LEFT CONTENT */}
        <div className="mirissa-left" data-aos="fade-right">

          <h2>Kandy</h2>
          <p>
            Kandy is a city located withing the culture triangle vibrant city renowed for its culture heritage,sceni beauty & its religious significant.
          </p>

          <div className="mirissa-gallery">
            <img src={kandy1} alt="Mirissa View" />
            <img src={kandy2} alt="Mirissa View" />
          </div>

          <p>
            Kandy is a UNESCO word heritage city.
          </p>

          <h2>Main tourist attractions in kandy world heritage city</h2>

          <ul className="mirissa-list">
            <li>Temple of tooth</li>
            <li>Kandyan culture shore</li>
            <li>Peradeniya botanical garden</li>
            <li>Udawaththa kale forest reserve</li>
            <li>Kandy lake</li>
            <li>Hanthana bird park</li>
          </ul>

          {/* EXTRA CONTENT FROM SCREENSHOT */}
          <div className="mirissa-extra" data-aos="fade-up">

            <div className="mirissa-top-gallery">
              <img src={kandy3} alt="Mirissa View" />
              <img src={kandy4} alt="Mirissa View" />
              <img src={kandy5} alt="Mirissa View" />
            </div>

            <h2>Temple of The Tooth</h2>

            <p>
              The Temple of the Sacred Tooth Relic (Sri Dalada Maligawa) in Kandy is one of the most revered Buddhist sites in Sri Lanka and a UNESCO World Heritage Site.
              It houses the Buddha's tooth relic, which has immense spiritual significance and has influenced Sri Lanka's history and culture through the centuries.
            </p>

            <h3>Relics of the Holy Tooth</h3>

            <p>
              Engraved in a golden box, the relic is kept in the temple's inner sanctum.
              Even though visitors cannot see the relic itself, the box is displayed during the religious ceremonies.
            </p>

            <h3>Architectural grandeur</h3>

            <p>
              The temple features traditional Sinhalese architecture with intricate woodwork, paintings, and golden decorations.
              The octagonal Pattirippuva, which was originally used by royalty, is a prominent feature in the temple complex.
            </p>

            <p>
              The salad perahara is held annually in the month of August & grand procession honors the Tooth Relic with live cultural performances,
              including traditional drumming, dances, and elephants adorned with exquisite decorations.
            </p>

            <h3>Daily rituals (Thevava)</h3>

            <p>
              The temple performs three daily worships: morning, noon, and evening rituals, during which offerings are made to the relics, accompanied by drumming and singing.
            </p>

            <h3>The temple complex</h3>

            <p>
              The complex includes a museum that displays items related to the relic and Kandy's history. Kandy Lake, which is located nearby, contributes to the serene atmosphere of this place.
            </p>

            <h3>Historical significance</h3>

            <p>
              The relic symbolized royal power in Sri Lanka for centuries. The protection of this relic was one of the primary responsibilities of the monarchs.
            </p>

            <h3>Historical significance</h3>

            <ul className="mirissa-list">
              <li>Dress code: Modest clothing that covers shoulders and knees is required.</li>
              <li>Best time to visit: Early in the morning or in the afternoon during the rituals for a more spiritual experience.</li>
              <li>Photography: Allowed outside the inner sanctum, but respect the sacred atmosphere.</li>
            </ul>

            <h2>You can include this destinations in your travel itinerary which we Ceylon Grace Travels will give you unforgettable experience</h2>

            <h3>kandyan culture show</h3>

            <p>
              Kandy is famous for its rich cultural heritage and traditional dances, which are a major attraction for tourists.
              The Kandyan dance (Udarata Natum) is the highlight, deeply rooted in Sri Lanka's history and traditions.
              Here is a brief summary of how it is presented to tourists.
            </p>

            <h3>Key features of Kandy dance for tourists:</h3>

            <ul className="mirissa-list">
              <li>Performances in cultural shows: Regular performances are held at cultural centers in Kandy, such as in the Kandy Arts Association hall.</li>
              <li>Traditional attire: The dancers wear ornate costumes in bright colors, metal breastplates, and headdresses.</li>
              <li>Drumming and music: Accompanied by traditional drums, like Geta Bera. The rhythms enhance the impression.</li>
              <li>Fire Walking : Many performances end with an exciting fire walking act.</li>
              <li>Legend: Each dance narrates popular legends or religious stories from Buddhist traditions and provides cultural understanding.</li>
            </ul>

            <p>
              You can include this destinations in your travel itinerary which we Ceylon Grace Travels will give you unforgettable experience
            </p>

            <h2>PERADENIYA BOTANICAL GARDEN</h2>

            <p>
              The Peradeniya Botanical Garden is located near Kandy, Sri Lanka, and is one of the largest and most well-known botanical gardens in the country.
              Covering an area of 147 acres, it houses an extensive collection of tropical plants, including rare orchids, palm trees, and medicinal plants.
              In the garden, there is also a Royal Palm Avenue, a tropical greenhouse, and a gigantic Java fig tree.
              It is a popular place for both tourists and locals, offering a tranquil environment to explore nature and enjoy its beauty.
            </p>

            <p>
              Inside the garden we will taking you orchid house, Avenida de Palmas, Large Java Fig Tree,Medicinal garden,historical trees,bird watching & Diverse Plant Collection
            </p>

            <h2>Main features here in peradeniya botanical garden as below.</h2>

            <p>
              1. The Orchid House: It has more than 300 species of living and rare orchids.
            </p>

            <p>
              2. Avenida de Palmas: Famous avenues with tall palm trees, perfect for photographs.
              Avenida de las Palmas: Famous avenues with tall palm trees, perfect for photographs.
            </p>

            <p>
              3. Large Java Fig Tree: A tree with a wide crown, perfect for picnics.
            </p>

            <p>
              4. Medicinal garden: Shows the rich Ayurvedic heritage of the island.
            </p>

            <p>
              5. Historical trees; Some trees were planted by prominent individuals, including the British royal family and world leaders.
            </p>

            <p>
              6. Birdwatching: Observe birds with bright colors, such as grebes and parrots.
            </p>

            <p>
              7. Diverse Plant Collection: The garden houses more than 4000 plant species, including orchids, spices, medicinal plants, and palms.
            </p>

            <p>
              8. Historical significance: The place has a rich history that dates back to the 1800s and was originally used for the cultivation of coffee and cinnamon.
            </p>

            <p>
              9. Picturesque beauty: Surrounded by the Mahaweli River, the gardens offer a picturesque setting with luxurious green areas and enchanting landscapes. Picturesque Beauty: Surrounded by the Mahaweli River, the gardens offer a picturesque environment with luxurious green areas and enchanting landscapes.
            </p>

            <p>
              10. National Herbarium: Related to gardens, in Sri Lanka, there is the national herbarium, which houses an extensive collection of plant specimens.
            </p>

            <p>
              You can include this destinations in your travel itinerary which we Ceylon Grace Travels will give you unforgettable experience
            </p>

            <h2>Udawaththakalee Forest reserve</h2>

            <p>
              The Udawatta Kele forest area, located near Kandy, is a reserve of great historical and ecological significance. It served as a royal forest for the Kandy kings and is now a popular spot for nature lovers, historians, and ornithologists.
            </p>

            <p>
              1. Biodiversity: Home to a diverse flora and fauna, including rare birds, reptiles, and mammals.
            </p>

            <p>
              2. The trails are picturesque: Picturesque trails: Well-maintained through dense forests, ideal for trekking and leisurely walks. Picturesque trails: Well-maintained paths through dense forests, perfect for trekking and leisurely walks.
            </p>

            <p>
              3. Historical sites: Historical sites: Includes Buddhist monasteries and ancient meditation caves.
            </p>

            <p>
              4. View from the viewpoint: View from the viewpoint: The highest trails offer impressive views of the city of Kandy and its surroundings.
            </p>

            <p>
              5. Educational value: Excellent for studying the local eco systems in Sri Lanka and the efforts You can include this destinations in your travel itinerary which we Ceylon Grace Travels will give you unforgettable experience
            </p>

            <h2>Kandy lake</h2>

            <p>
              Kandy Lake, also known as the Sea of Milk (Kiri Muhuda),
              is a tranquil artificial lake in the heart of the city of Kandy,
              created in 1807 by King Sri Vikrama Rajasinghe.
              This place is popular among both locals and tourists due to its beauty and historical significance.
            </p>

            <h3>Main attractions in kandy lake</h3>

            <p>
              1.Picturesque walks: A cobblestone path surrounds the lake,
              perfect for peaceful walks with views of the water and the surrounding hills.
              Picturesque walks: A cobblestone path surrounds the lake,
              perfect for leisurely walks with views of the water and the surrounding hills.
            </p>

            <p>
              2. Island in the lake: Small island with legends that it was a royal harem or a place for storing royal treasures.
              Island in the lake: Small island with legends that it was a royal harem or a place for storing royal treasures.
            </p>

            <p>
              3. Historical monuments: Includes the Valakulu Wall, a decorative stone wall built by the king.
            </p>

            <p>
              4. Biological diversity: Home to various fish, birds, and, sometimes, lizards.
            </p>

            <p>
              5. Night views: The lake and its surroundings are beautifully illuminated, creating a calm atmosphere.
            </p>

            <h3>You can include this destinations in your travel itinerary which we Ceylon Grace Travels will give you unforgettable experience</h3>

            <h2>Hanthana Bird park</h2>

            <p>
              Hantana Bird Park, located in the Hantana area near Kandy, Sri Lanka, is a peaceful retreat dedicated to the conservation and exhibition of a wide variety of bird species.
              It is the perfect place for bird lovers, nature enthusiasts, and families seeking an educational and relaxing experience.
            </p>

            <h3>Wide variety of birds:</h3>

            <p>
              Home to exotic, endemic, and migratory bird species. Includes peacocks, parrots, eagles, owls, and many others, showcasing the diversity of birdlife.
            </p>

            <h3>Interactive experiences:</h3>

            <p>
              Visitors can observe the birds up close and, in some cases, interact with them in specially designated areas.
            </p>

            <h3>Beautiful landscapes:</h3>

            <p>
              The park is located in the center of a green area with well-maintained walkways and a picturesque view of the Hantana hills.
            </p>

            <h3>Educational opportunities:</h3>

            <p>
              Offers an understanding of bird behavior, their habitats, and conservation efforts. Ideal for children and for anyone interested in birds.
            </p>

            <h3>Relaxing atmosphere:</h3>

            <p>
              The calm atmosphere and the cool climate make this place ideal for resting in nature.
            </p>

            <h3>Tips for the visit:</h3>

            <p>
              Best time: Early in the morning or late in the evening, to enjoy the cool weather and the birds' more active behavior.
            </p>

            <p>
              Duration: Spend 2-3 hours for a thorough visit.
            </p>

            <p>
              Accessibility: Easily accessible from the city of Kandy, about 10-15 minutes by car.
            </p>

          </div>

          {/* ACTIVITIES SECTION */}
          <div className="mirissa-activities" data-aos="fade-up">

            <h2>You can include this destinations in your travel itinerary which we Ceylon Grace Travels will give you unforgettable experience</h2>

            <details className="activity-box" open>
              <summary>• Cultural Experiences</summary>

              <p>
                Kandy offers an enriching cultural journey with the iconic Temple of the Tooth, a revered Buddhist site,
                and vibrant Kandyan dance performances showcasing traditional music, colorful costumes, and captivating legends.
              </p>

              <div className="activity-gallery">
                <div className="activity-card">
                  <img src={act1} alt="Whale Watching" />
                  <p>Temple of the Tooth</p>
                </div>

                <div className="activity-card">
                  <img src={act2} alt="Turtle Watching" />
                  <p>Kandyan dance</p>
                </div>

                <div className="activity-card">
                  <img src={act3} alt="Turtle Feeding" />
                  <p>Kandy Lake</p>
                </div>
              </div>
            </details>

            <details className="activity-box">
              <summary>• Nature Escapes</summary>

              <p>
                Immerse yourself in nature at the Peradeniya Botanical Garden's vast greenery and Udawattakele Forest Reserve's serene trails,
                where diverse flora, fauna, and picturesque landscapes create a peaceful retreat from city life.
              </p>

              <div className="activity-gallery">
                <div className="activity-card">
                  <img src={act4} alt="Whale Watching" />
                  <p>Peradeniya Botanical Garden</p>
                </div>

                <div className="activity-card">
                  <img src={act5} alt="Turtle Watching" />
                  <p>Udawattakele Forest Reserve</p>
                </div>

                <div className="activity-card">
                  <img src={act6} alt="Turtle Feeding" />
                  <p>Picturesque landscapes</p>
                </div>
              </div>
            </details>

            <details className="activity-box">
              <summary>• Leisure and Relaxation</summary>

              <p>
                Kandy Lake’s tranquil waters and Hanthana Bird Park’s lush greenery offer perfect settings for leisurely walks, birdwatching, and unwinding amidst scenic views and the region’s calming, cool climate.
              </p>

              <div className="activity-gallery">
                <div className="activity-card">
                  <img src={act7} alt="Whale Watching" />
                  <p>Hanthana Bird Park</p>
                </div>

                <div className="activity-card">
                  <img src={act8} alt="Turtle Watching" />
                  <p>Unwinding amidst scenic views</p>
                </div>

                <div className="activity-card">
                  <img src={act9} alt="Turtle Feeding" />
                  <p>Cool climate</p>
                </div>
              </div>
            </details>
          </div>

          {/* PARROT ROCK SECTION */}
          <div className="mirissa-parrot-rock" data-aos="fade-up">

            <div className="parrot-gallery">
              <img src={kandy6} alt="Parrot Rock Beach" />
              <img src={kandy7} alt="Seafood Dish" />
            </div>

          </div>

        </div>

        {/* RIGHT INQUIRY FORM */}
        <div className="mirissa-form" data-aos="fade-left">
          <h3>Make an Inquiry</h3>

          <form
            onSubmit={(e) => {
              e.preventDefault();

              const name = e.target.name.value;
              const email = e.target.email.value;
              const country = e.target.country.value;
              const code = e.target.code.value;
              const phone = e.target.phone.value;
              const arrival = e.target.arrival.value;
              const departure = e.target.departure.value;
              const interest = e.target.interest.value;
              const vehicle = e.target.vehicle.value;   // ✅ NEW
              const adults = e.target.adults.value;
              const kids = e.target.kids.value;
              const message = e.target.message.value;

              const fullMessage = `
                📌 NEW TOUR BOOKING

                👤 Name: ${name}
                📧 Email: ${email}
                🌍 Country: ${country}
                📞 Phone: ${code} ${phone}
                📅 Arrival: ${arrival}
                📅 Departure: ${departure}
                🎯 Interest: ${interest}
                🚗 Vehicle Preference: ${vehicle}
                👨‍👩‍👧 Adults: ${adults}
                🧒 Kids: ${kids}

                💬 Message: ${message} 
              `;

              // ✅ SEND WHATSAPP
              const whatsappNumber = "94717726099"; // your WhatsApp number
              const whatsappURL =
                "https://wa.me/" + whatsappNumber + "?text=" + encodeURIComponent(fullMessage);

              window.open(whatsappURL, "_blank");

              // ✅ SEND EMAIL
              const mailto =
                "mailto:ceylongracetravels@gmail.com" +
                "?subject=" + encodeURIComponent("New Tour Booking") +
                "&body=" + encodeURIComponent(fullMessage);

              window.location.href = mailto;

              alert("✅ Your Booking is Send!");
            }}
          >
            <input name="name" type="text" placeholder="Name *" />
            <input name="email" type="email" placeholder="Email Address *" />

            <select name="country" required>
              <option value="">Choose Your Country *</option>
              <option value="Afghanistan">Afghanistan</option>
              <option value="Albania">Albania</option>
              <option value="Algeria">Algeria</option>
              <option value="Andorra">Andorra</option>
              <option value="Angola">Angola</option>
              <option value="Antigua and Barbuda">Antigua and Barbuda</option>
              <option value="Argentina">Argentina</option>
              <option value="Armenia">Armenia</option>
              <option value="Australia">Australia</option>
              <option value="Austria">Austria</option>
              <option value="Azerbaijan">Azerbaijan</option>
              <option value="Bahamas">Bahamas</option>
              <option value="Bahrain">Bahrain</option>
              <option value="Bangladesh">Bangladesh</option>
              <option value="Barbados">Barbados</option>
              <option value="Belarus">Belarus</option>
              <option value="Belgium">Belgium</option>
              <option value="Belize">Belize</option>
              <option value="Benin">Benin</option>
              <option value="Bhutan">Bhutan</option>
              <option value="Bolivia">Bolivia</option>
              <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
              <option value="Botswana">Botswana</option>
              <option value="Brazil">Brazil</option>
              <option value="Brunei">Brunei</option>
              <option value="Bulgaria">Bulgaria</option>
              <option value="Burkina Faso">Burkina Faso</option>
              <option value="Burundi">Burundi</option>
              <option value="Cabo Verde">Cabo Verde</option>
              <option value="Cambodia">Cambodia</option>
              <option value="Cameroon">Cameroon</option>
              <option value="Canada">Canada</option>
              <option value="Central African Republic">Central African Republic</option>
              <option value="Chad">Chad</option>
              <option value="Chile">Chile</option>
              <option value="China">China</option>
              <option value="Colombia">Colombia</option>
              <option value="Comoros">Comoros</option>
              <option value="Congo, Democratic Republic of the">Congo, Democratic Republic of the</option>
              <option value="Congo, Republic of the">Congo, Republic of the</option>
              <option value="Costa Rica">Costa Rica</option>
              <option value="Côte d’Ivoire">Côte d’Ivoire</option>
              <option value="Croatia">Croatia</option>
              <option value="Cuba">Cuba</option>
              <option value="Cyprus">Cyprus</option>
              <option value="Czech Republic">Czech Republic</option>
              <option value="Denmark">Denmark</option>
              <option value="Djibouti">Djibouti</option>
              <option value="Dominica">Dominica</option>
              <option value="Dominican Republic">Dominican Republic</option>
              <option value="Ecuador">Ecuador</option>
              <option value="Egypt">Egypt</option>
              <option value="El Salvador">El Salvador</option>
              <option value="Equatorial Guinea">Equatorial Guinea</option>
              <option value="Eritrea">Eritrea</option>
              <option value="Estonia">Estonia</option>
              <option value="Eswatini">Eswatini</option>
              <option value="Ethiopia">Ethiopia</option>
              <option value="Fiji">Fiji</option>
              <option value="Finland">Finland</option>
              <option value="France">France</option>
              <option value="Gabon">Gabon</option>
              <option value="Gambia">Gambia</option>
              <option value="Georgia">Georgia</option>
              <option value="Germany">Germany</option>
              <option value="Ghana">Ghana</option>
              <option value="Greece">Greece</option>
              <option value="Grenada">Grenada</option>
              <option value="Guatemala">Guatemala</option>
              <option value="Guinea">Guinea</option>
              <option value="Guinea-Bissau">Guinea-Bissau</option>
              <option value="Guyana">Guyana</option>
              <option value="Haiti">Haiti</option>
              <option value="Honduras">Honduras</option>
              <option value="Hungary">Hungary</option>
              <option value="Iceland">Iceland</option>
              <option value="India">India</option>
              <option value="Indonesia">Indonesia</option>
              <option value="Iran">Iran</option>
              <option value="Iraq">Iraq</option>
              <option value="Ireland">Ireland</option>
              <option value="Israel">Israel</option>
              <option value="Italy">Italy</option>
              <option value="Jamaica">Jamaica</option>
              <option value="Japan">Japan</option>
              <option value="Jordan">Jordan</option>
              <option value="Kazakhstan">Kazakhstan</option>
              <option value="Kenya">Kenya</option>
              <option value="Kiribati">Kiribati</option>
              <option value="Korea, North">Korea, North</option>
              <option value="Korea, South">Korea, South</option>
              <option value="Kuwait">Kuwait</option>
              <option value="Kyrgyzstan">Kyrgyzstan</option>
              <option value="Laos">Laos</option>
              <option value="Latvia">Latvia</option>
              <option value="Lebanon">Lebanon</option>
              <option value="Lesotho">Lesotho</option>
              <option value="Liberia">Liberia</option>
              <option value="Libya">Libya</option>
              <option value="Liechtenstein">Liechtenstein</option>
              <option value="Lithuania">Lithuania</option>
              <option value="Luxembourg">Luxembourg</option>
              <option value="Madagascar">Madagascar</option>
              <option value="Malawi">Malawi</option>
              <option value="Malaysia">Malaysia</option>
              <option value="Maldives">Maldives</option>
              <option value="Mali">Mali</option>
              <option value="Malta">Malta</option>
              <option value="Marshall Islands">Marshall Islands</option>
              <option value="Mauritania">Mauritania</option>
              <option value="Mauritius">Mauritius</option>
              <option value="Mexico">Mexico</option>
              <option value="Micronesia">Micronesia</option>
              <option value="Moldova">Moldova</option>
              <option value="Monaco">Monaco</option>
              <option value="Mongolia">Mongolia</option>
              <option value="Montenegro">Montenegro</option>
              <option value="Morocco">Morocco</option>
              <option value="Mozambique">Mozambique</option>
              <option value="Myanmar (Burma)">Myanmar (Burma)</option>
              <option value="Namibia">Namibia</option>
              <option value="Nauru">Nauru</option>
              <option value="Nepal">Nepal</option>
              <option value="Netherlands">Netherlands</option>
              <option value="New Zealand">New Zealand</option>
              <option value="Nicaragua">Nicaragua</option>
              <option value="Niger">Niger</option>
              <option value="Nigeria">Nigeria</option>
              <option value="North Macedonia">North Macedonia</option>
              <option value="Norway">Norway</option>
              <option value="Oman">Oman</option>
              <option value="Pakistan">Pakistan</option>
              <option value="Palau">Palau</option>
              <option value="Panama">Panama</option>
              <option value="Papua New Guinea">Papua New Guinea</option>
              <option value="Paraguay">Paraguay</option>
              <option value="Peru">Peru</option>
              <option value="Philippines">Philippines</option>
              <option value="Poland">Poland</option>
              <option value="Portugal">Portugal</option>
              <option value="Qatar">Qatar</option>
              <option value="Romania">Romania</option>
              <option value="Russia">Russia</option>
              <option value="Rwanda">Rwanda</option>
              <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
              <option value="Saint Lucia">Saint Lucia</option>
              <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
              <option value="Samoa">Samoa</option>
              <option value="San Marino">San Marino</option>
              <option value="Sao Tome and Principe">Sao Tome and Principe</option>
              <option value="Saudi Arabia">Saudi Arabia</option>
              <option value="Senegal">Senegal</option>
              <option value="Serbia">Serbia</option>
              <option value="Seychelles">Seychelles</option>
              <option value="Sierra Leone">Sierra Leone</option>
              <option value="Singapore">Singapore</option>
              <option value="Slovakia">Slovakia</option>
              <option value="Slovenia">Slovenia</option>
              <option value="Solomon Islands">Solomon Islands</option>
              <option value="Somalia">Somalia</option>
              <option value="South Africa">South Africa</option>
              <option value="South Sudan">South Sudan</option>
              <option value="Spain">Spain</option>
              <option value="Sri Lanka">Sri Lanka</option>
              <option value="Sudan">Sudan</option>
              <option value="Suriname">Suriname</option>
              <option value="Sweden">Sweden</option>
              <option value="Switzerland">Switzerland</option>
              <option value="Syria">Syria</option>
              <option value="Taiwan">Taiwan</option>
              <option value="Tajikistan">Tajikistan</option>
              <option value="Tanzania">Tanzania</option>
              <option value="Thailand">Thailand</option>
              <option value="Timor-Leste">Timor-Leste</option>
              <option value="Togo">Togo</option>
              <option value="Tonga">Tonga</option>
              <option value="Trinidad and Tobago">Trinidad and Tobago</option>
              <option value="Tunisia">Tunisia</option>
              <option value="Turkey">Turkey</option>
              <option value="Turkmenistan">Turkmenistan</option>
              <option value="Tuvalu">Tuvalu</option>
              <option value="Uganda">Uganda</option>
              <option value="Ukraine">Ukraine</option>
              <option value="United Arab Emirates">United Arab Emirates</option>
              <option value="United Kingdom">United Kingdom</option>
              <option value="United States">United States</option>
              <option value="Uruguay">Uruguay</option>
              <option value="Uzbekistan">Uzbekistan</option>
              <option value="Vanuatu">Vanuatu</option>
              <option value="Vatican City">Vatican City</option>
              <option value="Venezuela">Venezuela</option>
              <option value="Vietnam">Vietnam</option>
              <option value="Yemen">Yemen</option>
              <option value="Zambia">Zambia</option>
              <option value="Zimbabwe">Zimbabwe</option>
            </select>

            <div className="phone-row">
              <input name="code" className="code" type="text" placeholder="Code" />
              <input name="phone" className="phone" type="text" placeholder="Phone Number *" />
            </div>

            <label htmlFor="arrival">Arrival Date</label>
            <input name="arrival" type="date" />

            <label htmlFor="departure">Departure Date</label>
            <input name="departure" type="date" />

            <select name="interest">
              <option value="">Choose Your Interest *</option>
              <option value="Eco">Eco</option>
              <option value="Beach">Beach</option>
              <option value="Cultural">Cultural</option>
              <option value="Adventure">Adventure</option>
              <option value="Wild Life">Wild Life</option>
              <option value="Relax and Wellness">Relax and Wellness</option>
              <option value="Honeymoon">Honeymoon</option>
              <option value="Ramayana Trail">Ramayana Trail</option>
              <option value="All in one Trails">All in one Trails</option>
            </select>

            <select name="vehicle">
              <option value="">Select Vehicle Type *</option>
              <option value="Sedan – Toyota Prius (3 Pax)">Sedan – Toyota Prius (3 Pax)</option>
              <option value="Sedan – Toyota Axio (3 Pax)">Sedan – Toyota Axio (3 Pax)</option>
              <option value="Sedan – Honda Grace (3 Pax)">Sedan – Honda Grace (3 Pax)</option>
              <option value="Mini – Suzuki Wagon R (2 Pax)">Mini – Suzuki Wagon R (2 Pax)</option>
              <option value="Mini – Toyota Aqua (2 Pax)">Mini – Toyota Aqua (2 Pax)</option>
              <option value="Van – Suzuki Every (4 Pax)">Van – Suzuki Every (4 Pax)</option>
              <option value="Van – Mini Van (4 Pax)">Van – Mini Van (4 Pax)</option>
              <option value="Van – Toyota Noha (4 Pax)">Van – Toyota Noha (4 Pax)</option>
              <option value="Bus – Mitsubishi Rosa (12 Pax)">Bus – Mitsubishi Rosa (12 Pax)</option>
              <option value="Bus – King Long (12 Pax)">Bus – King Long (12 Pax)</option>
            </select>

            <input name="adults" type="number" placeholder="Adults *" />
            <input name="kids" type="number" placeholder="Kids" />

            <textarea name="message" placeholder="Enter your message"></textarea>

            <button type="submit">SUBMIT</button>
          </form>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section" data-aos="fade-up">
        <div className="cta-box">
          <div className="cta-left">
            <img src={require("../../assets/hile.png")} className="cta-icon" alt="icon" />
            <div className="cta-text">
              <h2>Ready To Adventure And Enjoy Natural</h2>
              <p>Reach Ceylon Grace Travels For A Secure, Luxurious, And Unforgettable Adventure!</p>
            </div>
          </div>

          <img src={require("../../assets/plan.png")} className="cta-plane" alt="plane" />

          <button className="cta-btn">LET’S GET STARTED</button>
        </div>
      </section>
    </div>
  );
}

export default Kandy;
